import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { createQueryClient } from './queryClient';
import { AuthProvider } from './auth/AuthContext';
import { ToastProvider } from './components/ToastProvider';
import { initTheme } from './theme';
// Self-hosted variable fonts (doc 26): bundled by Vite, subset by unicode-range,
// no request leaves the origin. The optical-size builds carry weight AND opsz.
import '@fontsource-variable/inter/opsz.css';
import '@fontsource-variable/newsreader/opsz.css';
import '@fontsource-variable/newsreader/opsz-italic.css';
import './styles/tokens.css';
import './styles/customer.css';
import './styles/portal.css';
import './styles.css';

// Apply the persisted theme to <html> before the first render so a dark-mode
// reload doesn't flash light. Light remains the default (theme.ts).
initTheme();

const queryClient = createQueryClient();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ToastProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ToastProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
